import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';
import Tile from '../_generic/tile/Tile';
import BasketSocialCues from './BasketSocialCues';

export default function ActionBar({ children, atolProtected }) {
  const theme = useContext(ThemeContext);

  return (
    <>
      <Tile extraClasses="action-bar">
        <div className="action-bar__content">
          {children}
          <div className="action-bar__social-cues">
            <BasketSocialCues atolProtected={atolProtected} isLighter />
          </div>
          <div className="action-bar__cta" id="top-cta-button" />
        </div>
      </Tile>
      <style jsx>{`
        :global(.tile--action-bar) {
          margin-bottom: 30px;
          position: sticky;
          top: 0;
          z-index: 1001;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          :global(.tile--action-bar) {
            position: relative;
            top: auto;
            z-index: 0;
          }
        }
        .action-bar__content {
          display: flex;
          flex-direction: column;
          flex-flow: row wrap;
        }
        .action-bar__cta {
          width: 195px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding: 10px 8px;
        }
        .action-bar__social-cues {
          display: none;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .action-bar__social-cues {
            display: flex;
            font-size: 13px;
            flex-direction: column;
            flex-grow: 1;
            justify-content: center;
            padding: 10px 8px;
          }
          .action-bar__cta {
            padding: 10px 8px 10px 0;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .action-bar__social-cues {
            width: 100%;
            align-items: center;
            text-align: center;
          }
          .action-bar__cta {
            width: 100%;
            align-items: center;
            text-align: center;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          :global(.tile--action-bar) {
            margin-bottom: 0;
          }
          .action-bar__social-cues {
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
}

ActionBar.propTypes = {
  atolProtected: PropTypes.bool,
  children: PropTypes.node,
};
